/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Customer} customerObj
 * @param {Tabs} tabs
 * @constructor
 */
export let Popup = function ($, config, library, customerObj, tabs) {
  /**
   * @type {string}
   */
  let template = `
<div class="slp-popup">
    <div class="slp-popup-in">
        <div class="slp-popup-box" data-loyalty-popup="box">
            <a class="slp-popup-close" href="#" title="Close" data-loyalty-popup="close">&times;</a>
            <div class="slp-popup-content" data-loyalty-popup="content"></div>
        </div>
    </div>
</div>
`;

  /**
   * @type {HTMLElement}
   */
  let popupElement, popupBox, popupContent, popupClose;

  /**
   *
   */
  let init = () => {
    popupElement = document.createElement('div');
    popupElement.className = 'slp-popup-wrapper';
    popupElement.style.display = 'none';
    popupElement.style.position = 'relative';
    popupElement.style.zIndex = '100000';
    popupElement.innerHTML = library.mustache().render(
      config.customization().popupTemplate || template
    );

    popupBox = popupElement.querySelector('[data-loyalty-popup="box"]');
    popupContent = popupElement.querySelector('[data-loyalty-popup="content"]');
    popupClose = popupElement.querySelector('[data-loyalty-popup="close"]');
    if (config.getCustomer().id) {
      tabs.render(popupContent, ['stats', 'info', 'terms']);
    } else {
      tabs.render(popupContent, ['info', 'terms']);
    }

    document.body.appendChild(popupElement);
    initPopupBehaviour();
  };

  /**
   *
   */
  let initPopupBehaviour = () => {
    $(popupElement).click((e) => {
      let target = e.target;
      while (target !== document.body) {
        if (target === popupElement || target === popupClose) {
          break;
        }
        if (target === popupBox) {
          return;
        }
        target = target.parentNode;
      }
      this.hide();
      return false;
    });
  };

  const POPUP_NAME = 'loyalty_popup';
  const ESC_CODE = 27;

  /**
   *
   */
  this.show = function () {
    let self = this;
    $(document).on('keyup.' + POPUP_NAME, function(e) {
      if (e.keyCode === ESC_CODE) {
          self.hide();
      }
    });

    $(popupElement).fadeIn({
      complete: () => config.customization().onPopupShown(this)
    });
  };

  /**
   *
   */
  this.hide = function () {
    $(document).unbind('keyup.' + POPUP_NAME);

    $(popupElement).fadeOut();
  };

  /**
   * @return {{popup: HTMLElement, box: HTMLElement, content: HTMLElement}}
   */
  this.getDomElements = function () {
    return {
      popup: popupElement,
      box: popupBox,
      content: popupContent
    };
  };

  init();
};